export enum Syndicates {
	UK = "UK",
	DE = "prosieben",
	DE_RTL = "RTL",
	FR = "FR",
	AU = "Tabcorp",
	CA = "Canada",
	MX = "Mexico",
	ES = "Spain",
}
